(function ($) {
    $(document).ready(function () {
        // Picking a gift card passes its period and price to the Stripe checkout button
        $('.gift_options').on('click', '.gift_option', function () {
            const $option = $(this);
            const $section = $option.closest('.pricing_section');

            $section.find('.gift_option').removeClass('is-active').attr('aria-pressed', 'false');
            $option.addClass('is-active').attr('aria-pressed', 'true');

            $section.find('.stripe-checkout-btn').attr({
                'data-months': $option.attr('data-months'),
                'data-price': $option.attr('data-price')
            });
        });
    });
})(jQuery);
